import {
  REFRESH_DATE_KEY,
  REFRESH_COUNT_KEY,
  MAX_REFRESHES_PER_DAY,
} from '../constants';
import type { InfluencerRefreshLimits } from '../types';

export function getTodayStr(): string {
  return new Date().toISOString().split('T')[0];
}

/**
 * Computes whether selected refresh is allowed today based on localStorage
 * rate-limit counters.
 */
export function getRefreshLimits(): InfluencerRefreshLimits {
  const todayStr = getTodayStr();
  const lastRefreshDate = localStorage.getItem(REFRESH_DATE_KEY);
  const refreshCountStr = localStorage.getItem(REFRESH_COUNT_KEY);
  const refreshCount =
    lastRefreshDate === todayStr ? parseInt(refreshCountStr || '0', 10) : 0;
  const canRefreshSelected = refreshCount < MAX_REFRESHES_PER_DAY;

  return { canRefreshSelected, refreshCount };
}

/**
 * Increments the daily refresh count in localStorage and returns the new count.
 */
export function recordRefreshUsage(): number {
  const { refreshCount } = getRefreshLimits();
  const todayStr = getTodayStr();
  const newCount = refreshCount + 1;
  localStorage.setItem(REFRESH_DATE_KEY, todayStr);
  localStorage.setItem(REFRESH_COUNT_KEY, newCount.toString());
  return newCount;
}
